import { UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { useTrackedMutation as useMutation } from '@ais-ui/performance-tracking';

import { Bookmark } from './types';
import { saveBookmark } from './saveBookmark';
import { useSession } from '../../SessionProvider';

export const useSaveBookmark = (): UseMutationResult<
  unknown,
  Error,
  Bookmark,
  null
> => {
  const { olSession } = useSession();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (bookmark: Bookmark) => {
      return saveBookmark(olSession, bookmark);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getBookmarks'] });
    },
  }, 'bookmark:save');
};
